import { serviceContext, type ServiceContext } from '$lib/ServiceContext';
import _ from 'lodash';
import type { HandleClientError } from '@sveltejs/kit';
import { PUBLIC_SENTRY_ENVIRONMENT } from '$env/static/public';

const getSentry = _.once(async () => {
	const Sentry = await import('@sentry/sveltekit');

	// If you don't want to use Session Replay, remove the `Replay` integration,
	// `replaysSessionSampleRate` and `replaysOnErrorSampleRate` options.
	Sentry.init({
		dsn: 'https://446e3710807bf172b879a4dc446aa640@o4510454556196864.ingest.de.sentry.io/4511157039202384',
		environment: PUBLIC_SENTRY_ENVIRONMENT,
		tracesSampleRate: 1,
		integrations: [Sentry.consoleLoggingIntegration({ levels: ['info', 'log', 'warn', 'error'] })],
		enableLogs: true,
		sendDefaultPii: true
	});

	return Sentry;
});

export const handleError: HandleClientError = async ({ error, event, status, message }) => {
	const Sentry = getSentry();
	// ServiceContext may be undefined here, if handleError gets
	// called // before the layout has the chance to initialize it
	const posthog = (serviceContext as ServiceContext | undefined)?.posthogService.getPosthog();

	const errorId = crypto.randomUUID();

	// example integration with https://sentry.io/
	Sentry.then(($sentry) =>
		$sentry.captureException(error, {
			extra: { event, errorId, status, message }
		})
	);

	// SvelteKit 2.0 offers a reliable way to check for a 404 error:
	if (status !== 404) {
		posthog?.then(($posthog) => $posthog?.captureException(error));
	}
};
